import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ isOpen, play, onConfirm, onCancel }) => {
  if (!isOpen || !play) return null;

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-foreground/50 backdrop-blur-sm"
        onClick={onCancel}
        aria-hidden="true"
      />
      <div className="relative bg-popover rounded-lg border border-border shadow-elevation-3 max-w-md w-full animate-fade-in">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center flex-shrink-0">
              <Icon name="AlertTriangle" size={24} className="text-error" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-popover-foreground mb-2">
                Delete Play
              </h3>
              <p className="text-sm text-muted-foreground">
                Are you sure you want to delete "{play?.title}"? This action cannot be undone.
              </p>
            </div>
          </div>

          <div className="bg-error/5 rounded-lg p-4 mb-6 border border-error/20">
            <p className="text-sm font-medium text-error mb-2">This will permanently delete:</p>
            <ul className="space-y-1 text-sm text-muted-foreground">
              <li className="flex items-center gap-2">
                <Icon name="Check" size={14} className="text-error" />
                <span>{play?.lineCount} lines of dialogue</span>
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={14} className="text-error" />
                <span>{play?.audioFilesUploaded} audio files</span>
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={14} className="text-error" />
                <span>{play?.glossaryTermsAssigned} glossary assignments</span>
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={14} className="text-error" />
                <span>All student progress data</span>
              </li>
            </ul>
          </div>

          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              onClick={onCancel}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={() => onConfirm(play?.id)}
              iconName="Trash2"
              iconPosition="left"
              fullWidth
            >
              Delete Play
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;